import { api } from '@/services'

export async function addFreightRequest(id: string, transporterId: string) {
  try {
    const { data } = await api.post('Cart/SelecionarFrete', null, {
      params: {
        CheckoutId: id,
        TransporterId: transporterId
      }
    })

    return { data }
  } catch (error) {
    console.error(error)
  }
}
